import Api from './api'
import store from '@/store'

const resource = '/channels'
export default {
  get() {
    return Api.get(`${resource}/index/${store.state.route.params.category}`)
  },
  show() {
    return Api.get(`${resource}/show/${store.state.route.params.category}/${store.state.route.params.channel}`)
  },
  create(categorySlug, data) {
    return Api.put(`${resource}/store/${categorySlug}`, data)
  },
  reorder(categorySlug, data) {
    return Api.post(`${resource}/reorder/${categorySlug}`, data)
  },
  update(categorySlug, channelSlug, data) {
    return Api.patch(`${resource}/update/${categorySlug}/${channelSlug}`, data)
  },
  image(categorySlug, channelSlug, file) {
    let formData = new FormData();
    formData.append('file', file)

    return Api.post(`${resource}/image/${categorySlug}/${channelSlug}`, formData)
  },
  imageDestroy(categorySlug, channelSlug) {
    return Api.delete(`${resource}/image/${categorySlug}/${channelSlug}`)
  },
  read() {
    return Api.get(`${resource}/read/${store.state.route.params.category}/${store.state.route.params.channel}`)
  },
  destroy(categorySlug, channelSlug) {
    return Api.delete(`${resource}/destroy/${categorySlug}/${channelSlug}`)
  }
}
